module.exports = [{
      plugin: require('/Users/dwhite/website/web/node_modules/gatsby-plugin-layout/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('/Users/dwhite/website/web/node_modules/gatsby-plugin-typography/gatsby-browser.js'),
      options: {"plugins":[],"pathToConfigModule":"src/utils/typography"},
    },{
      plugin: require('/Users/dwhite/website/web/node_modules/gatsby-remark-images/gatsby-browser.js'),
      options: {"plugins":[],"maxWidth":700},
    },{
      plugin: require('/Users/dwhite/website/web/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
